import { useQuickbooksNavState } from "./quickbooks/use-quickbooks-access";
import { useReceiptsEnabled } from "./use-receipts-enabled";
import { AP_TAB, type ApTabValue } from "./utils";

export interface ApTab {
  tab: ApTabValue;
  warning?: string;
}

export const useApTabs = (): ApTab[] => {
  const receiptsEnabled = useReceiptsEnabled();
  const quickbooks = useQuickbooksNavState();

  return Object.values(AP_TAB)
    .filter(
      (tab) =>
        (tab !== AP_TAB.receipts || receiptsEnabled) &&
        (tab !== AP_TAB.quickbooks || quickbooks.isListed),
    )
    .map((tab) => ({
      tab,
      warning:
        tab === AP_TAB.quickbooks && quickbooks.needsReconnect
          ? "Needs reconnecting"
          : undefined,
    }));
};
